import React, { useState } from 'react';

const faqs = [
    {
        question: 'What website solutions do you provide?',
        answer: 'We offer full-service platforms including online ordering, reservations, digital gift cards, and more.',
    },
    {
        question: 'How long does website setup take?',
        answer: 'Most projects are completed in 2-4 weeks depending on content and features.',
    },
    {
        question: 'Can I manage my website content?',
        answer: 'Yes. We offer a user-friendly dashboard so you can update your site anytime.',
    },
    {
        question: 'Do you offer ongoing website support?',
        answer: 'Absolutely. We offer continuous support and updates to keep your site running smoothly.',
    },
];

const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                <p className="faq-subtitle">Quick answers to your top questions.</p>
                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div key={index} className="faq-card">
                            <button className="faq-question" onClick={() => toggle(index)}>
                                {faq.question}
                                <span className={`arrow ${activeIndex === index ? 'rotate' : ''}`}>⌄</span>
                            </button>
                            {activeIndex === index && <div className="faq-answer">{faq.answer}</div>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
